import { createUseStyles } from 'react-jss'
// import Color from 'color'
// import hexToRgba from '../../helpers/hex-to-rgba'

const useStyles = createUseStyles(() => ({
  cartLines: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-l)',
  },
  item: {
    color: 'var(--ui-color-text)',
    fontSize: '1.4rem',
    lineHeight: 1.8,
    borderBottom: '1px solid var(--ui-color-grey-300)',
    position: 'relative',
    overflow: 'hidden',
  },
  itemTitle: {
    // fontSize: '2rem',
  },
  addon: {
    opacity: 0.75,
    lineHeight: 1.25,
    '&::before': {
      content: '"- "',
    },
  },
  itemError: {
    color: 'var(--ui-color-danger)',
    lineHeight: 1.25,
    marginTop: '1rem',
  },
  editButton: {
    appearance: 'none',
    background: 'transparent',
    border: 0,
    padding: 0,
    width: '100%',
    position: 'absolute',
    zIndex: 9,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    opacity: 0,
    userSelect: 'none',
    overflow: 'hidden',
    textIndent: '-99999rem',
    cursor: 'pointer',
  },
  clearIcon: {
    margin: 0,
    color: 'currentColor',
    '&:focus': {
      outline: 'none',
    },
  },
  clearIconButton: {
    background: 'transparent',
    border: 0,
    padding: 'var(--ui-spacer-m)',
    position: 'absolute',
    zIndex: 10,
    right: '-0.5rem',
    top: 'calc(var(--ui-spacer-m) * -0.75)',
    cursor: 'pointer',
    color: 'var(--ui-color-text)',
    '&:focus': {
      outline: 'none',
    },
  },
  appVersion: {
    color: 'var(--ui-color-aux)',
    fontSize: '1rem',
  },
}))

export default useStyles
